import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import { SelectInput, TextField } from "../inputs";
const businessOptions = [
  {
    label: "Appraisal Company",
    value: "Appraisal Company",
  },
  { label: "Asset Manager", value: "Asset Manager" },
  { label: "Audit, Compliance, Risk", value: "Audit, Compliance, Risk" },
  { label: "BPO Provider", value: "BPO Provider" },
  { label: "Field Services", value: "Field Services" },
  { label: "Legal Services", value: "Legal Services" },
  { label: "Mortgage Originator", value: "Mortgage Originator" },
  { label: "Mortgage Servicer", value: "Mortgage Servicer" },
  { label: "NPL, Note buyer", value: "NPL, Note buyer" },
  { label: "Technology Company", value: "Technology Company" },
  { label: "Title Company", value: "Title Company" },
  { label: "Other", value: "Other" },
];
export interface SignupProfessionalStepTwoInterface {
  initialData: {
    title: string;
    location: string;
    line: string;
    description: string;
  };
  schema: any;
  handleAction: (type: string, data?: any) => void;
}
const SignupProfessionalStepTwo = ({
  initialData,
  handleAction,
  schema,
}: SignupProfessionalStepTwoInterface) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={5}
      width="100%"
      height="100%"
    >
      <Stack alignItems="center" spacing={1.5}>
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Welcome, John!
        </Typography>
        <Typography variant="h4" fontWeight={500} textAlign="center">
          Your profile helps us connect you with the most relevant events,
          speaker and/or sponsorship opportunities
        </Typography>
      </Stack>
      <Formik
        initialValues={initialData}
        validationSchema={Yup.object().shape(schema)}
        onSubmit={(value) => handleAction("submit", value)}
        render={({
          handleChange,
          values,
          handleBlur,
          touched,
          setFieldValue,
          errors,
          handleSubmit,
        }: any) => (
          <form
            onSubmit={handleSubmit}
            style={{ width: "100%", height: "100%" }}
          >
            <Stack spacing={1.5}>
              <TextField
                label="Business Title*"
                fullWidth
                style={{ border: 0, padding: 0 }}
                id="title"
                helperText={
                  touched.title && errors !== null ? errors.title : ""
                }
                error={touched.title && errors !== null && errors.title}
                onChange={handleChange}
                value={values.title}
                onBlur={handleBlur}
              />
              <Stack>
                <TextField
                  label="Location*"
                  fullWidth
                  style={{ border: 0, padding: 0 }}
                  id="location"
                  helperText={
                    touched.location && errors !== null ? errors.location : ""
                  }
                  error={touched.location && errors !== null && errors.location}
                  onChange={handleChange}
                  value={values.location}
                  onBlur={handleBlur}
                />
                <Typography>
                  {" "}
                  We’ll use your location to show events near you
                </Typography>
              </Stack>

              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Please describe your business line*</Typography>
                <SelectInput
                  placeholder="Select One"
                  value={values.line}
                  roundedCorners={true}
                  onChange={(event) =>
                    setFieldValue("line", event.target.value)
                  }
                  options={businessOptions}
                />
              </Stack>
              {values.line === "Other" ? (
                <TextField
                  label="Your business line*"
                  type="text"
                  fullWidth
                  id="description"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.description && errors !== null
                      ? errors.description
                      : ""
                  }
                  error={
                    touched.description && errors !== null && errors.description
                  }
                  onChange={handleChange}
                  value={values.description}
                  onBlur={handleBlur}
                />
              ) : null}

              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                  onClick={() => handleSubmit()}
                >
                  Next
                </Button>
              </Box>
            </Stack>
          </form>
        )}
      />
    </Stack>
  );
};
export default SignupProfessionalStepTwo;
